import { render, staticRenderFns } from "./RPopup.vue?vue&type=template&id=55e5182e&scoped=true&"
import script from "./RPopup.vue?vue&type=script&lang=js&"
export * from "./RPopup.vue?vue&type=script&lang=js&"
import style0 from "./RPopup.vue?vue&type=style&index=0&id=55e5182e&lang=scss&scoped=true&"
import style1 from "./RPopup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5182e",
  null
  
)

export default component.exports